import React from 'react';
import { Link } from 'react-router-dom';


export default function CalltoAction() {
  return (




<section className='lets_discuss_projects mb-5 mt-5'> 

    <div className='call-to-action'>
    <div className='container showUp'>
        <div className='row'>
            <div className='col-12'>
                <h1>Let's Discuss your Projects</h1>
                <p>We pride ourselves with our ability to perform and deliver results. Use the form below to discuss your project needs with our team, we will get back asap.</p>
            </div>

            <div className='col-12 text-center mt-2'>  <Link className='contact_us' to='/contact'>Contact Us</Link> </div>

        </div>

    </div>
    </div>

</section>



  )
}
